// Components==============
import React, { createContext } from 'react';
// =========================

type Props = {
  id: number;
  type: ProcessType;
  amount?: number;
  done?: number;
  contribution?: boolean;
};

export const DreamModalItemContext = createContext({} as Props);

export default function DreamModalItem({
  children,
  ...props
}: { children: React.ReactNode } & Props) {
  return (
    <DreamModalItemContext.Provider value={props}>
      {children}
    </DreamModalItemContext.Provider>
  );
}
